import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = [
  'enterpriseButtonClick',
  'choosePlan',
  'pricingPageShown',
  'pricingBusinessGetStartedClick',
  'moreMinutesHomePageClick',
  'moreMinutesAccountClick',
  'buyAdditionalMinutesAccount',
  'upgradeCreatorClick',
  'upgradeCreatorProClick',
  'upgradeBusinessClick',
  'switchAnnualCreatorClick',
  'switchAnnualCreatorProClick',
  'switchAnnualBusinessClick',
  'pricingSwitchAnnual',
  'pricingSwitchMonthly',
  'bundleSwitchCreatorPro',
  'bundleSwitchBusiness',
  'pricingVisitedPaidUser',
  'minutesModalViewPlansClick',
  'payLessMinutesButton',
  'buyMinutesModalShown',
  'buyMinutesButtonHomePageClick',
  'notActiveTrialBannerOpened',
  'notActiveTrialBannerContinueWithPlanClick',
  'activeTrialBannerContinueWithPlanClick',
] as const;

export const pricingEvents = getMappedEvents([...EVENTS], {
  shouldSendSubscriptionData: true,
});
